<template>
  <div class="vendor-trends-page">
    <div v-if="!loading">
      <trend-item
        title="Language pairs KPIs"
        v-model="params"
        type="language"
        :languages-list="languagesList"
        :qa-methods-list="qaMethodsList"
        :qa-models-list="qaModelsList"
        :lsp-list="lspList"
        :text-category-list="textCategoryList"
        :industry-field-list="industryFieldList"
        :graphics-data="graphicsData.LanguagesKpi"
        :graphics-loader="ajaxLoading"
      />
      <trend-item
        title="Industry sectors KPIs"
        v-model="params"
        type="industry"
        :languages-list="languagesList"
        :qa-methods-list="qaMethodsList"
        :qa-models-list="qaModelsList"
        :lsp-list="lspList"
        :text-category-list="textCategoryList"
        :industry-field-list="industryFieldList"
        :graphics-data="graphicsData.IndustrySectorsKpi"
        :graphics-loader="ajaxLoading"
      />
      <trend-item
        title="Document types KPIs"
        v-model="params"
        type="document"
        :languages-list="languagesList"
        :qa-methods-list="qaMethodsList"
        :qa-models-list="qaModelsList"
        :lsp-list="lspList"
        :text-category-list="textCategoryList"
        :industry-field-list="industryFieldList"
        :graphics-data="graphicsData.DoctypesKpi"
        :graphics-loader="ajaxLoading"
      />
      <trend-item
        title="QA models KPIs"
        v-model="params"
        type="qa"
        :languages-list="languagesList"
        :qa-methods-list="qaMethodsList"
        :qa-models-list="qaModelsList"
        :lsp-list="lspList"
        :text-category-list="textCategoryList"
        :industry-field-list="industryFieldList"
        :graphics-data="graphicsData.QaModelsKpi"
        :graphics-loader="ajaxLoading"
      />
      <trend-item
        title="Evaluation methods KPIs"
        v-model="params"
        type="evaluation"
        :languages-list="languagesList"
        :qa-methods-list="qaMethodsList"
        :qa-models-list="qaModelsList"
        :lsp-list="lspList"
        :text-category-list="textCategoryList"
        :industry-field-list="industryFieldList"
        :graphics-data="graphicsData.EvalMethodsKpi"
        :graphics-loader="ajaxLoading"
      />
    </div>
    <pre-loader v-else :preloader-status="true" />
  </div>
</template>

<script>
import Vue from 'vue';
import Api from '@/utils/api';
import moment from 'moment';

export default Vue.extend({
  name: 'DashBoardVendorsTrends',
  components: {
    'pre-loader': () => import('@/components/preloader/index.vue'),
    'trend-item': () => import('./trendsItems/index.vue'),
  },
  data: () => ({
    loading: true,
    ajaxLoading: false,

    textCategoryList: Array(),
    industryFieldList: Array(),
    languagesList: Array(),
    qaMethodsList: Array(),
    qaModelsList: Array(),
    lspList: Array(),

    params: {
      creation_date: Array(),
      industry_field: Array(),
      doc_type: Array(),
      sourceLanguage: null,
      targetLanguage: null,
      lsp: null,
      qaModel: Array(),
      qaMethod: Array(),
    },

    graphicsData: {
      DoctypesKpi: Array(),
      EvalMethodsKpi: Array(),
      IndustrySectorsKpi: Array(),
      LanguagesKpi: Array(),
      QaModelsKpi: Array(),
    },
  }),
  watch: {
    params: {
      deep: true,
      handler() {
        this.getData();
      },
    },
  },
  methods: {
    getFilters () {
      return Promise.all([
        this.$store.dispatch('GET_LANGUAGES').then((data) => {
          this.languagesList = [...data];
          this.languagesList.unshift({
            ID: '',
            LanguageName: ' All',
            CountryISOCode: 'world',
          });
        }),
        this.$store.dispatch('GET_INDUSTRY').then((data) => {
          this.industryFieldList = [...data];
        }),
        this.$store.dispatch('GET_DOCUMENT_TYPES').then((data) => {
          this.textCategoryList = [...data];
        }),
        this.$store.dispatch('GET_QA_METHODS').then((data) => {
          this.qaMethodsList = [...data];
        }),
        Api.getEvaluationMethods().then((resp) => {
          if (resp.data.Status) {
            this.qaModelsList = [...resp.data.Data];
          }
        }),
        Api.user.getLsp().then((resp) => {
          if (resp.data.Status) {
            this.lspList = [...resp.data.Data].map((el) => ({
              ID: el.ID,
              Name: el.Username,
            }));
          }
        }),
      ]);
    },
    getData() {
      if (this.params.lsp) {
        this.ajaxLoading = true;
        Api.dashboard.getVendorTrends(
          this.getBackendParams(this.params)
        ).then((data) => {
          this.graphicsData = { ...data };
        }).finally(() => {
          this.ajaxLoading = false;
        });
      }
    },
    getBackendParams(params) {
      const output = {
        SelectedDates: params.creation_date.length > 0
          ? [ ...params.creation_date.map((e) => moment.utc(e).unix()) ] : null,
        LspId: params.lsp ? params.lsp.ID : null,
        SourceLanguageId: params.sourceLanguage ? params.sourceLanguage.ID : null,
        TargetLanguageId: params.targetLanguage ? params.targetLanguage.ID : null,
        IndustrySectorIds: params.industry_field.map((e) => e.ID),
        DocumentTypeIds: params.doc_type.map((e) => e.ID),
        QaModelIds: params.qaModel.map((e) => e.ID),
        EvMethodIds: params.qaMethod.map((e) => e.ID),
      };
      Object.keys(output).forEach((key) => {
        if (!output[key]) {
          delete output[key];
        }
      });
      return output;
    },
  },
  created () {
    this.getFilters().then(() => {
      this.loading = false;
    });
  },
});
</script>

<style lang="scss">

</style>
